import React from "react";
import { Link } from "react-router-dom";
import Services from "../../api/service";
import Projects from "../../api/project";
import blogs from "../../api/blogs";

const SubmitHandler = (e) => {
  e.preventDefault();
};

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogSidebar = (props) => {
  return (
    <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
      <div className="blog-sidebar">
        <div className="widget about-widget">
          <div className="img-holder">
            <img
              src={
                "https://cleener-react.wpocean.com/static/media/about-widget.48d952ae.jpg"
              }
              alt=""
            />
          </div>

          <h4>Jenny Watson</h4>
          <p>
            Hallo! Mooie mensen. Ik ben de auteur van deze blog. Lees onze
            berichten - blijf bij ons.
          </p>
          <div className="social">
            <ul className="clearfix">
              <li>
                <a onClick={ClickHandler} to="#">
                  <i className="ti-facebook"></i>
                </a>
              </li>
              <li>
                <a onClick={ClickHandler} to="#">
                  <i className="ti-twitter-alt"></i>
                </a>
              </li>
              <li>
                <a onClick={ClickHandler} to="#">
                  <i className="ti-linkedin"></i>
                </a>
              </li>
              <li>
                <a onClick={ClickHandler} to="#">
                  <i className="ti-pinterest"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="aw-shape"></div>
        </div>
        <div className="widget search-widget">
          <form onSubmit={SubmitHandler}>
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Zoek bericht..."
              />
              <button type="submit">
                <i className="ti-search"></i>
              </button>
            </div>
          </form>
        </div>
        <div className="widget category-widget">
        <h3>Categorieën</h3>
          <ul>
            {Services.slice(0, 6).map((service, Sitem) => (
              <li key={Sitem}>
                <a onClick={ClickHandler} to={`#`}>
                  {`${service.sTitle} Cleaning`} <span>{service.Id}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="widget recent-post-widget">
        <h3>Gerelateerde Berichten</h3>
          <div className="posts">
            {blogs.map((blog, bl) => (
              <div className="post" key={bl}>
                <div className="img-holder">
                  <img src={blog.screens} alt="" />
                </div>
                <div className="details">
                  <h4>
                    <a onClick={ClickHandler} href={`#`}>
                      {blog.title}
                    </a>
                  </h4>
                  <span className="date">{blog.create_at}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="widget wpo-instagram-widget">
          <div className="widget-title">
            <h3>Diensten</h3>
          </div>
          <ul className="d-flex">
            {Projects.slice(0, 3).map((project, Sitem) => (
              <li key={Sitem}>
                <a
                  onClick={ClickHandler}
                  href={`#`}
                >
                  <img src={project.pImg} alt="" />
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="widget tag-widget">
          <h3>Tags</h3>
          <ul>
            <li>
              <a onClick={ClickHandler} href="#">
                Keuken
              </a>
            </li>
            <li>
              <a onClick={ClickHandler} href="#">
                Kantoor
              </a>
            </li>
            <li>
              <a onClick={ClickHandler} href="#">
                Ramen
              </a>
            </li>
            <li>
              <a onClick={ClickHandler} href="#">
                Vloer
              </a>
            </li>
            <li>
              <a onClick={ClickHandler} href="#">
                Loodgieterij
              </a>
            </li>
            <li>
              <a onClick={ClickHandler} href="#">
                Winkel
              </a>
            </li>
            <li>
              <a onClick={ClickHandler} href="#">
                Badkamer
              </a>
            </li>
          </ul>
        </div>

        <div className="wpo-contact-widget widget">
          <h2>
            Hoe Wij <br /> U Kunnen Helpen!
          </h2>
          <p>
            Of het nu gaat om uw woning, kantoor of pand – Alakram
            Schoonmaakdiensten staat voor u klaar. Ons professionele team levert
            betrouwbare en hoogwaardige schoonmaak op maat.
          </p>
          <a onClick={ClickHandler} to="/contact">
            Neem Contact Op
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
